/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pause } from '../../models/pause';
import { PauseRequest } from '../../models/pause-request';

export interface UpsertChannelOrderingPause$Params {
  'Active-Tenant-Identifier': string;
      body: PauseRequest
}

export function upsertChannelOrderingPause(http: HttpClient, rootUrl: string, params: UpsertChannelOrderingPause$Params, context?: HttpContext): Observable<StrictHttpResponse<Pause>> {
  const rb = new RequestBuilder(rootUrl, upsertChannelOrderingPause.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Pause>;
    })
  );
}

upsertChannelOrderingPause.PATH = '/ordering/pauses';
